export type ShellWindow = Window &
  typeof globalThis & {
    _satellite?: {
      track?: (event: string) => void;
    };
    dataLayer: DataLayer;
    GetAcceptedCookieCategories: () => {
      functional: boolean;
      marketing: boolean;
      necessary: boolean;
      optimization: boolean;
      personalization: boolean;
      preferences: boolean;
      security: boolean;
    };
  };

type DataLayer = {
  custId: string;
  environment: string;
  language: string;
  applicationName: string;
  pageName: string;
  pageurl: string;
  website: string;
};

export type TrackingEvent = "tool_started" | "tool_completed";

export function waitForTrackingToBeReady() {
  const shellWindow = window as ShellWindow;
  return new Promise<void>((resolve) => {
    if (shellWindow._satellite && shellWindow._satellite.track) {
      resolve();
      return;
    }

    const check = () => {
      setTimeout(() => {
        if (shellWindow._satellite && shellWindow._satellite.track) {
          resolve();
          return;
        }

        check();
      }, 1000);
    };

    check();
  });
}

export function sendTrackingEvent(event: TrackingEvent) {
  const shellWindow = window as ShellWindow;
  const dataLayer: DataLayer = {
    ...shellWindow.dataLayer,
    applicationName: "Leasing calculator (public)",
    pageName: "public|leasing|calculator",
    website: "public",
  };

  shellWindow.dataLayer = dataLayer;
  if (shellWindow._satellite && shellWindow._satellite.track) {
    shellWindow._satellite.track(event);
  }
}
